import { css as h, LitElement as u, html as i } from "lit";
import { state as m, customElement as p } from "lit/decorators.js";
import { focusRing as g, reducedMotion as v } from "../styles/shared.js";
var b = Object.defineProperty, k = Object.getOwnPropertyDescriptor, d = (e, t, r, o) => {
  for (var a = o > 1 ? void 0 : o ? k(t, r) : t, l = e.length - 1, n; l >= 0; l--)
    (n = e[l]) && (a = (o ? n(t, r, a) : n(a)) || a);
  return o && a && b(t, r, a), a;
};
const c = "kl-theme";
let s = class extends u {
  constructor() {
    super(...arguments), this.theme = "dark";
  }
  get storage() {
    try {
      return globalThis.localStorage ?? window.localStorage;
    } catch {
      return;
    }
  }
  connectedCallback() {
    var o;
    super.connectedCallback();
    const e = (o = this.storage) == null ? void 0 : o.getItem(c), t = document.documentElement.getAttribute("data-theme"), r = e ?? t ?? (typeof matchMedia == "function" && matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
    this.apply(r, !1);
  }
  apply(e, t) {
    var r;
    this.theme = e, document.documentElement.setAttribute("data-theme", e), t && ((r = this.storage) == null || r.setItem(c, e)), this.dispatchEvent(
      new CustomEvent("kl-theme-change", {
        detail: { theme: e },
        bubbles: !0,
        composed: !0
      })
    );
  }
  toggle() {
    this.apply(this.theme === "dark" ? "light" : "dark", !0);
  }
  render() {
    const e = this.theme === "dark" ? "light" : "dark";
    return i`
      <button part="button" aria-label="Switch to ${e} theme" @click=${this.toggle}>
        ${this.theme === "dark" ? i`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <circle cx="12" cy="12" r="4" />
              <path
                d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
              />
            </svg>` : i`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
            </svg>`}
      </button>
    `;
  }
};
s.styles = [
  g,
  v,
  h`
      :host {
        display: inline-flex;
      }

      button {
        display: grid;
        place-items: center;
        inline-size: 44px;
        block-size: 44px;
        background: transparent;
        border: 1px solid var(--kl-border, #e4e4e7);
        border-radius: var(--kl-radius-md, 0.5rem);
        color: var(--kl-ink-secondary, #3f3f46);
        cursor: pointer;
        padding: 0;
        transition:
          color var(--kl-duration-fast, 150ms) var(--kl-ease-default, ease),
          border-color var(--kl-duration-fast, 150ms) var(--kl-ease-default, ease);
      }

      button:hover {
        color: var(--kl-accent, #0d9488);
        border-color: var(--kl-accent-border, color-mix(in srgb, #0d9488 30%, transparent));
      }

      svg {
        inline-size: 18px;
        block-size: 18px;
      }
    `
];
d([
  m()
], s.prototype, "theme", 2);
s = d([
  p("kl-theme-toggle")
], s);
export {
  s as KlThemeToggle
};
